import DOMPurify from 'dompurify';

// Configure link hardening hook
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  // Set all elements owning target to target=_blank
  if (node.tagName === 'A' && node.hasAttribute('href')) {
    node.setAttribute('target', '_blank');
    // Prevent tabnapping by adding rel="noopener noreferrer"
    node.setAttribute('rel', 'noopener noreferrer');
  }

  // Set non-HTML/MathML links to xlink:show=new
  if (
    !node.hasAttribute('target') &&
    (node.hasAttribute('xlink:href') || node.hasAttribute('href'))
  ) {
    node.setAttribute('xlink:show', 'new');
  }
});

export const sanitizeRichText = (dirtyHtml: string): string =>
  DOMPurify.sanitize(dirtyHtml, {
    // Only allow safe URL protocols
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
    FORBID_TAGS: [
      'script',
      'style',
      'iframe',
      'object',
      'embed',
      'math',
      'svg',
      'form',
      'input',
      'button',
      'textarea',
      'select',
      'option',
      'video',
      'audio',
      'canvas',
    ],

    FORBID_ATTR: [
      'onerror',
      'onclick',
      'onload',
      'onmouseover',
      'onmouseenter',
      'onmouseleave',
      'onfocus',
      'onblur',
      'onchange',
      'onsubmit',
      'oninput',
      'onkeydown',
      'onkeyup',
      'onkeypress',
      'formaction',
      'srcset',
    ],

    KEEP_CONTENT: true,
  });
